import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';

import { HttpErrorDialogInterceptor } from '@app/core/services/interceptors/http-error-dialog-interceptor.service';
import { AccountsAPI } from './api/accounts.service';
import { CommonAPI } from './api/common.service';
import { KeyFiguresAPI } from './api/key-figures-api.service';
import { MonitorAPI } from './api/monitor.service';
import { PGAPIService } from './api/pg-api.service';
import { ProductsAPI } from './api/products.service';
import { ScenariosAPI } from './api/scenarios.service';
import { SignupAPI } from './api/signup.service';
import { UsersAPI } from './api/users.service';
import { ConnectAppGuardService } from './services/connect-app-guard.service';
import { GlobalErrorHandler } from './services/error-handler.service';
import { LoggingService } from './services/error-logging.service';
import { GlobalSideNavService } from './services/global-side-nav.service';
import { HttpAuthInterceptor } from './services/interceptors/http-auth-interceptor.service';
import { HttpErrorTransformInterceptor } from './services/interceptors/http-error-transform-interceptor.service';
import { HttpSessionTimeoutInterceptor } from './services/interceptors/http-session-timeout.interceptor';
import { LayoutService } from './services/layout.service';
import { StateService } from './services/state.service';
import { TourService } from './services/tour.service';
import { UnsavedFormGuard } from './services/unsaved-form-guard.service';
import { UnsavedModalAlertService } from './services/unsaved-modal-alert.service';
import { UtilitiesService } from './services/utilities.service';
import { StoreModule } from './store/store.module';

@NgModule({
  imports: [StoreModule],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorTransformInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorDialogInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpSessionTimeoutInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    LoggingService,
    UtilitiesService,
    StateService,
    LayoutService,
    ConnectAppGuardService,
    GlobalSideNavService,
    UnsavedModalAlertService,
    TourService,
    CommonAPI,
    AccountsAPI,
    ProductsAPI,
    KeyFiguresAPI,
    ScenariosAPI,
    UsersAPI,
    SignupAPI,
    MonitorAPI,
    PGAPIService,
    UnsavedFormGuard,
  ],
})
export class CoreModule {}
